import { createSelector } from "reselect";
import { AppState } from "state/store";
const selector = (state: AppState) => state.settings;

export default createSelector([selector], (data) => data);